import Stack from "@mui/material/Stack";
import { PAGINATION_LIMIT } from "constants";
import { useEffect } from "react";
import { StyledPagination } from "./Pagination";
import { convertNum } from "helper/convert-num";

export default function PaginationCM(props) {
  const count = props.count
    ? Math.ceil(
        props.limit ? props.count / props.limit : props.count / PAGINATION_LIMIT
      )
    : 0;
  const changeInputValue = () => {
    const inp = document.getElementById("paginationInput");
    const convertedNum = parseInt(convertNum(inp.value));
    inp.blur();
    props.handleChange(inp, convertedNum > count ? count : convertedNum);
    inp.value = "";
  };

  useEffect(() => {
    const inp = document.getElementById("paginationInput");
    inp && inp.remove();
    if (count >= 8) {
      const liEl = document.createElement("li");
      const mainEl = document.querySelector(".MuiPagination-root ul");
      const addIndex = mainEl.children.length - 1;
      const inputEl = document.createElement("input");
      inputEl.placeholder = " ";
      inputEl.id = "paginationInput";
      inputEl.onchange = changeInputValue;
      inputEl.onkeydown = function (event) {
        if (
          (event.keyCode >= 48 && event.keyCode <= 57) ||
          event.keyCode === 8 ||
          event.keyCode === 13
        ) {
          return event.target.value;
        } else {
          event.preventDefault();
        }
      };
      liEl.appendChild(inputEl);
      mainEl.insertBefore(liEl, mainEl.children[addIndex]);
    }
  }, [props.count]);
  return (
    <Stack spacing={2} mx="auto" my={2} mb={3}>
      <StyledPagination
        count={props.pages || count}
        page={props.page}
        onChange={props.onChange}
        color="primary"
      />
    </Stack>
  );
}
